module.exports = __webpack_public_path__ + "static/cover-25f401d4d44ef1af7333d2cce09af691.mp4";